<div id="authNickname-container">
    <mm-text-input-control [parentForm]="parentForm"
        [inputControlModel]="nicknameModel" [useDirty]="true"></mm-text-input-control>
    <div id="authNickname-messages">
        <div *ngIf="authNicknameIsInvalid" id="nickname-error-text" data-testid="nickname-error-text" class="alert-text"
            >{{ authNicknameValidationError }}</div>
        <div id="character-count">{{authNickname.value.length}}/{{nicknameModel.htmlMaxLength}}</div>
    </div>
</div>